console.log("loading around.js");

import "./around/aos";
import "./around/parallax.min";
import "./around/theme-switcher";
import "./around/theme.min";
import "./around/swiper-bundle.min";
